/**
 * @generated SignedSource<<d364fb3d7691afc7a9753da59d0a91af>>
 * @relayHash fe6ed7432af1a3342bf7ae86b5667b67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74f3acf7195af915f9968961a5fb9e989f33a9b3cba830de48d0aab93c7eec51

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPickerAtlasQuery$variables = {
  cloudId: string;
};
export type ProjectPickerAtlasQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPicker_Atlas">;
};
export type ProjectPickerAtlasQuery = {
  response: ProjectPickerAtlasQuery$data;
  variables: ProjectPickerAtlasQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPickerAtlasQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectPicker_Atlas"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPickerAtlasQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "ScalarField",
                "name": "accountId"
              },
              (v2/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
        "kind": "LinkedField",
        "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TownsquareUnshardedWorkspaceSummary",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "cloudId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "concreteType": "TownsquareUnshardedUserCapabilities",
                    "kind": "LinkedField",
                    "name": "userCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareUnshardedCapability",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "capability"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "capabilityContainer"
                          }
                        ]
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "74f3acf7195af915f9968961a5fb9e989f33a9b3cba830de48d0aab93c7eec51",
    "metadata": {},
    "name": "ProjectPickerAtlasQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2948919b46c076b76def512ee4c32b35";

export default node;
